import script from "./CtaContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaContactSection.vue?vue&type=script&setup=true&lang=js"

import "./CtaContactSection.vue?vue&type=style&index=0&id=c1b86bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b86bae"]])

export default __exports__